export const JobStatus = Object.freeze({
  DRAFT: 'draft',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed',
});

export const jobStatusOptions = [
  { code: JobStatus.DRAFT, name: 'Draft' },
  { code: JobStatus.ACTIVE, name: 'Active' },
  { code: JobStatus.SUSPENDED, name: 'Suspended' },
  { code: JobStatus.CLOSED, name: 'Closed' },
];

export const payTypeOptions = [
  { code: 'Hourly', name: 'Hourly' },
  { code: 'Salary', name: 'Salary' },
  { code: 'Daily', name: 'Daily' },
];

export const CompensationType = Object.freeze({
  FIXED: 'Fixed',
  RANGE: 'Range',
});

export const compensationOptions = [
  { code: CompensationType.FIXED, name: 'Fixed Amount' },
  { code: CompensationType.RANGE, name: 'Pay Range (Min - Max)' },
];

export const benefitsOptions = [
  { code: 'Vision Insurance', name: 'Vision Insurance' },
  { code: 'Paid time off', name: 'Paid time off' },
  { code: 'Health Insurance', name: 'Health Insurance' },
  { code: 'Flexible Schedule', name: 'Flexible Schedule' },
  { code: 'Dental Insurance', name: 'Dental Insurance' },
  { code: '401(k)', name: '401(k)' },
  { code: 'Other', name: 'Other' },
];

export const scheduleTypeOptions = [
  { code: 'Full Time', name: 'Full Time' },
  { code: 'Part Time', name: 'Part Time' },
  { code: 'Flexible', name: 'Flexible' },
];

export const expectedDaysOptions = [
  { code: 1, name: 'Monday' },
  { code: 2, name: 'Tuesday' },
  { code: 3, name: 'Wednesday' },
  { code: 4, name: 'Thursday' },
  { code: 5, name: 'Friday' },
  { code: 6, name: 'Saturday' },
  { code: 0, name: 'Sunday' },
];

export const ApplicationStatus = Object.freeze({
  NEW: 'new',
  INTERESTED: 'interested',
  CONTACTED: 'contacted',
  REJECTED: 'rejected',
  HIRED: 'hired',
  WITHDRAWN: 'withdrawn',
  UNFINISHED: 'unfinished',
  ARCHIVED: 'archived',
});

export const applicationStatusOptions = [
  { code: ApplicationStatus.NEW, name: 'Needs Review' },
  { code: ApplicationStatus.INTERESTED, name: 'Interested' },
  { code: ApplicationStatus.CONTACTED, name: 'Contacted' },
  { code: ApplicationStatus.REJECTED, name: 'Rejected' },
  { code: ApplicationStatus.HIRED, name: 'Hired' },
];

export const jobTitleMaxLength = 50;
export const jobDescriptionMinLength = 150;
